__turbopack_context__.v({
  "vStack": "VStack-module-scss-module__0t2A2G__vStack",
});
